import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export default function HowWeWork({ data }) {
  if (!data) return null;
  const steps = data.steps || [];
  return (
    <section id="how-we-work" data-testid="how-we-work-section" className="relative bg-white py-24 sm:py-28 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div {...fadeUp} className="max-w-3xl">
          <span className="eyebrow">Process</span>
          <h2 className="mt-4 font-display font-bold text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            {data.title}
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">{data.intro}</p>
        </motion.div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.number}
              data-testid={`how-step-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-2xl border border-slate-200 bg-slate-50 p-7 hover:bg-navy transition-colors duration-500"
            >
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm text-brand-blue">{s.number}</span>
                <span className="h-px flex-1 bg-slate-200 group-hover:bg-white/15 transition-colors" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold text-navy group-hover:text-white transition-colors">{s.title}</h3>
              <p className="mt-2.5 text-sm text-slate-500 leading-relaxed group-hover:text-slate-300 transition-colors">{s.desc}</p>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-3 z-10 text-slate-300 group-hover:text-brand-blue">→</span>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
